// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/shell/RemixLink.tsx
// PLAN2 WP10 — §7.10. The LinkComponent given to DesignLinkProvider in root.tsx: http(s):, mailto:, tel: and #... hrefs
// render a plain <a>; everything else renders Remix's <Link prefetch="intent"> (C-105).
import { forwardRef } from "react";
import { Link } from "@remix-run/react";
import type { LinkComponentProps } from "@picosponsor/design";

export const RemixLink = forwardRef<HTMLAnchorElement, LinkComponentProps>(function RemixLink({ href, children, ...rest }, ref) {
  if (/^(https?:|mailto:|tel:|#)/.test(href)) return <a ref={ref} href={href} {...rest}>{children}</a>;
  return <Link ref={ref} to={href} prefetch="intent" {...rest}>{children}</Link>;
});
